import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardHeader } from '@/uiKit/atoms/card/CardHeader.tsx';
import { GeneratePrescriptionInfo } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfo.ts';

export type PrescriptionInfoFromTitleProps = {
  className?: string;
  onExit?: (data: Partial<GeneratePrescriptionInfo>) => void;
};

export const PrescriptionInfoFormTitle: React.FC<
  PrescriptionInfoFromTitleProps
> = ({ onExit, className }) => {
  const { t } = useTranslation();
  const formContext = useFormContext();

  return (
    <CardHeader
      title={t('diabetesForms.prescriptionGeneration')}
      variant="contained"
      onExit={() => onExit && onExit(formContext.getValues())}
      className={className}
    />
  );
};
